import { VBtn } from 'vuetify/lib/components/VBtn';

import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [!_vm.isSingleFile() ? _c("tool-bar", {
    attrs: {
      files: _vm.files,
      temporaryFiles: _vm.temporaryFiles
    },
    on: {
      delete: _vm.deleteFile
    }
  }) : _vm._e(), _c("items", {
    attrs: {
      files: _vm.files,
      items: _vm.temporaryFiles,
      required: _vm.required
    },
    on: {
      delete: _vm.deleteFile
    }
  }), !_vm.isSingleFile() ? _c("div", [_c("div", {
    staticClass: "file-upload-container",
    attrs: {
      id: _vm.idUploadContainer
    },
    on: {
      drop: function drop($event) {
        $event.preventDefault();
        return _vm.drop($event);
      },
      click: function click($event) {
        if ($event.target !== $event.currentTarget) return null;
        return _vm.clickOnInput();
      },
      dragover: function dragover($event) {
        $event.preventDefault();
        return _vm.dragover($event);
      },
      dragleave: function dragleave($event) {
        $event.preventDefault();
        return _vm.dragleave();
      }
    }
  }, [_c("label", {
    attrs: {
      for: _vm.id
    }
  }, [_c("span", [_vm._v("Upload a file or drag and drop")]), _c("input", {
    staticClass: "sr-only",
    attrs: {
      multiple: _vm.multiple,
      id: _vm.idInput,
      name: "file-upload",
      type: "file"
    },
    on: {
      change: function change($event) {
        _vm.clickedInput($event);
        _vm.isSingleFile();
      }
    }
  }), _c("div", {
    staticClass: "extension"
  }, [_c("div", [_vm._v(_vm._s(_vm.fileTypes.join(", ")) + " up to 10MB")]), _vm.additionalHint ? _c("div", [_vm._v(_vm._s(_vm.additionalHint))]) : _vm._e()])])])]) : _vm._e(), _vm.warningTriggered ? _c("p", {
    staticClass: "warning-text"
  }, [_vm._v(" Unable to upload the file. Only "), _c("strong", [_vm._v(_vm._s(_vm.filteredFileTypes.map(function (x) {
    return ".".concat(x.extension);
  }).join(", ")) + " up to 10MB")]), _vm._v(" is allowed. ")]) : _vm._e(), !_vm.hideUploadButton ? _c(VBtn, {
    staticClass: "dfwa-btn--secondary upload-btn",
    attrs: {
      disabled: !_vm.files.length,
      loading: _vm.uploading
    },
    on: {
      click: _vm.uploadAll
    }
  }, [_vm._v(" Upload ")]) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };